export var ONE_MB = 1048576;
export var FIVE_MB = ONE_MB * 5;
export var TEN_MB = ONE_MB * 10;
